


































































import { computed, defineComponent, PropType } from '@vue/composition-api';
import AttachedFilesViewArea from '@/components/SettouMessageBoard/components/AttachedFilesViewArea/index.vue';
import {
  BoardEntryFile,
} from '@/models/apis/settouMessageBoard/settouMessageBoardResponse';
import { BoardEntryConv } from '@/models/settouMessageBoard';
import { dtFormat } from '@/lib/dateHelper';
import {
  BOARD_ENTRY_ATTACHED_TO_CONTENT,
  BOARD_ENTRY_ATTACHED_TO_REPLY,
} from '@/components/SettouMessageBoard/utils/index';

export default defineComponent({
  components: {
    AttachedFilesViewArea,
  },
  props: {
    entry: {
      type: Object as PropType<BoardEntryConv>,
      required: true,
    },
    variant: {
      type: String as PropType<'pc' | 'sp'>,
      required: true,
    },
    canUseHonbuReportSearchConditions: {
      type: Boolean,
      required: true,
    },
    isHonbuBoard: {
      type: Boolean,
      required: true,
    },
    isMaintenanceBoard: {
      type: Boolean,
      required: true,
    },
    boardTabDispName: {
      type: String,
      required: true,
    },
    boardTabDepartmentDisp: {
      type: String,
      required: true,
    },
    isSuperAdmin: {
      type: Boolean,
      required: true,
    },
    isCreatableRole: {
      type: Boolean,
      required: true,
    },
    isRepliableRole: {
      type: Boolean,
      required: true,
    },
    editable: {
      type: Boolean,
      required: true,
    },
    deletable: {
      type: Boolean,
      required: true,
    },
    honbuReportLabel: {
      type: String,
      required: true,
    },
    editButtonClass: {
      type: String,
      required: true,
    },
  },
  setup(props, { emit }) {
    const variantClass = computed<string>(() => `topic--${props.variant}`);
    const canShowActions = computed<boolean>(() => {
      return props.isSuperAdmin || props.isCreatableRole || props.isRepliableRole;
    });
    const onClickImage = (images: BoardEntryFile[]): void => {
      emit('click-image', images);
    };
    const onEdit = (): void => {
      emit('edit', props.entry);
    };
    const onDelete = (): void => {
      emit('delete', props.entry);
    };

    return {
      variantClass,
      canShowActions,
      onClickImage,
      onEdit,
      onDelete,
      dtFormat,
      BOARD_ENTRY_ATTACHED_TO_CONTENT,
      BOARD_ENTRY_ATTACHED_TO_REPLY,
    };
  },
});
